module.exports = __webpack_public_path__ + "media/assets/good_at/Google-1a55c50d3174cc51ee3783dd3a0f5549.png";